import React, { Component } from 'react'
import { Table } from 'react-bootstrap';
import Firebase from '../Firebase';
import Questions from './Questions.json';
import { Collapse, Col, Row, Select } from 'antd';
const { Panel } = Collapse;
const { Option } = Select;
export class ScResult extends Component {
    constructor(props) {
        super(props);
        this.state = {
            result: [],
            schools: [],
            schools2: []
        }
    }
    componentDidMount() {
        Firebase.firestore().collection('SCSCORE').onSnapshot(this.getResult);

    }
    getListSchools = (querySnapshot) => {
        const schools = [];
        const schools2 = [];
        const { result } = this.state;
        querySnapshot.forEach((doc) => {
            let sumScore = 0;
            let maxScore = 0;
            const ans = [];

            result.forEach((doc2) => {

                if (doc.id === doc2.SchoolID) {
                    maxScore += 25;
                    doc2.Answer.forEach((doc3) => {
                        sumScore += parseInt(doc3)
                    })
                    ans.push(doc2);
                }
            })

            if (doc.data().Place === '1') {
                schools.push({
                    ID: doc.id,
                    ...doc.data(),
                    sumScore,
                    maxScore,
                    ans
                })
            } else {
                schools2.push({
                    ID: doc.id,
                    ...doc.data(),
                    sumScore,
                    maxScore,
                    ans
                })
            }

        })

        this.setState({
            schools,
            schools2
        })
    }
    getResult = (querySnapshot) => {
        const result = [];

        querySnapshot.forEach((doc) => {
            result.push({
                ID: doc.id,
                ...doc.data()
            })

        })

        this.setState({
            result,

        })
    }


    onSelect = (Version) => {
        Firebase.firestore().collection('Schools').where('Version', '==', Version).onSnapshot(this.getListSchools);

    }
    render() {
        console.log(this.state.schools)
        return (
            <div style={{ margin: 20 }}>
                <div style={{
                    backgroundColor: '#ffaaee', width: '100%', height: '100%', borderRadius: 5, padding: 10
                }}>
                    <h3 style={{ textAlign: 'center' }}><strong>ผลการพิจารณาประกวดโครงการ</strong></h3>
                </div>
                <div style={{
                    borderRadius: 5, padding: 5, justifyContent: 'center', display: 'flex'
                }}>
                    <Select style={{ width: 'auto', minWidth: 250 }} onChange={(str) => this.onSelect(str)} placeholder="เลือกรุ่น" >
                        <Option key={0} value="1">รุ่นที่ 1</Option>
                        <Option key={1} value="2">รุ่นที่ 2</Option>
                        <Option key={2} value="3">รุ่นที่ 3</Option>

                    </Select>

                </div>
                <div style={{
                    width: '100%', height: '100%', borderRadius: 5, padding: 10
                }}>
                    {this.state.schools.length === 0 &&
                        <h1 style={{ textAlign: 'center' }}>ไม่มีข้อมูล</h1>}
                    <Collapse accordion>

                        {this.state.schools.map((element, i) =>

                            <Panel style={{ fontSize: 20 }} header={element.Name} key={i}
                                extra={<span>
                                    <span style={{ color: '#80ff00' }}>{element.sumScore}</span>
                                    <span>{"/" + element.maxScore}</span>
                                </span>}>
                                <Table striped bordered hover size="sm" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th rowSpan="2" style={{ verticalAlign: 'top', textAlign: 'center' }}>ผู้ประเมิน</th>
                                            <th colSpan="5">คะแนน</th>
                                        </tr>
                                        <tr>
                                            <th style={{ textAlign: 'center' }}>ข้อ 1</th>
                                            <th style={{ textAlign: 'center' }}>ข้อ 2</th>
                                            <th style={{ textAlign: 'center' }}>ข้อ 3</th>
                                            <th style={{ textAlign: 'center' }}>ข้อ 4</th>
                                            <th style={{ textAlign: 'center' }}>ข้อ 5</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {element.ans.map((element, i2) =>
                                            <tr key={i2}>
                                                <td>{element.InputName}</td>
                                                <td>
                                                    {element.Answer[0]}
                                                </td>
                                                <td>
                                                    {element.Answer[1]}
                                                </td>
                                                <td>
                                                    {element.Answer[2]}
                                                </td>
                                                <td>
                                                    {element.Answer[3]}
                                                </td>
                                                <td>
                                                    {element.Answer[4]}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Panel>
                        )}
                    </Collapse>
                    <hr style={{ margin: 10, }}></hr>
                    {this.state.schools2.length === 0 &&
                        <h1 style={{ textAlign: 'center' }}>ไม่มีข้อมูล</h1>}
                    <Collapse accordion>

                        {this.state.schools2.map((element, i) =>

                            <Panel style={{ fontSize: 20 }} header={element.Name} key={i}
                                extra={<span>
                                    <span style={{ color: '#80ff00' }}>{element.sumScore}</span>
                                    <span>{"/" + element.maxScore}</span>
                                </span>}>
                                <Table striped bordered hover size="sm" style={{ width: '100%' }}>
                                    <thead>
                                        <tr>
                                            <th rowSpan="2" style={{ verticalAlign: 'top', textAlign: 'center' }}>ผู้ประเมิน</th>
                                            <th colSpan="5">คะแนน</th>
                                        </tr>
                                        <tr>
                                            <th style={{ textAlign: 'center' }}>ข้อ 1</th>
                                            <th style={{ textAlign: 'center' }}>ข้อ 2</th>
                                            <th style={{ textAlign: 'center' }}>ข้อ 3</th>
                                            <th style={{ textAlign: 'center' }}>ข้อ 4</th>
                                            <th style={{ textAlign: 'center' }}>ข้อ 5</th>
                                        </tr>

                                    </thead>
                                    <tbody>
                                        {element.ans.map((element, i2) =>
                                            <tr key={i2}>
                                                <td>{element.InputName}</td>
                                                <td>
                                                    {element.Answer[0]}
                                                </td>
                                                <td>
                                                    {element.Answer[1]}
                                                </td>
                                                <td>
                                                    {element.Answer[2]}
                                                </td>
                                                <td>
                                                    {element.Answer[3]}
                                                </td>
                                                <td>
                                                    {element.Answer[4]}
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Panel>
                        )}
                    </Collapse>
                </div>
            </div >
        )
    }
}

export default ScResult
